//#region src/redux/view-port/selectors.ts
var selectViewPort = () => (store) => {
	return store.viewPort.viewPort;
};
//#endregion
export { selectViewPort };

//# sourceMappingURL=selectors.js.map